import { render, staticRenderFns } from "./itemBox.vue?vue&type=template&id=61aae24c&scoped=true"
import script from "./itemBox.vue?vue&type=script&lang=js"
export * from "./itemBox.vue?vue&type=script&lang=js"
import style0 from "./itemBox.vue?vue&type=style&index=0&id=61aae24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aae24c",
  null
  
)

export default component.exports